const StatCard = ({ label, value, hint, tone = 'default' }) => (
  <div className={`stat-card stat-card--${tone}`}>
    <p className="stat-card__label">{label}</p>
    <p className="stat-card__value">{value}</p>
    {hint ? <p className="stat-card__hint">{hint}</p> : null}
  </div>
);

export default StatCard;
